import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  LabelList
} from "recharts";
import { CustomTooltip } from "../ChartUtils";


const AribaThreeColoredBarChart = ({data}) => {

  const CustomXAxisTick = ({ x, y, payload }) => {
    const entry = flattenData()[payload.index];
    const isCategoryTick = payload.index % 2 === 0; // Position category text between every two bars
  
    return (
      <g transform={`translate(${x},${y})`}>
        <text
          x={0}
          y={0}
          dy={16}
          textAnchor="middle"
          fill="#666"
          fontSize="12px"
        >
          {payload.value}
        </text>
        {isCategoryTick && (
          <text x={45} y={5} dy={32} textAnchor="start" fill="#666" fontSize="14px" style={{"fontWeight": 'bold'}}>
            {entry.category}
          </text>
        )}
      </g>
    );
  };
  const flattenData = () => {
    return data?.flatMap(item => [
      {
        name: "Pending Selection",
        RFI: item?.Pending?.RFI,
        RFP: item?.Pending?.RFP,
        Auction: item?.Pending?.Auction,
        category: item?.category,
        total: ((item?.Pending?.RFI ?? 0) + (item?.Pending?.RFP ?? 0) + (item?.Pending?.Auction ?? 0))
      },
      {
        name: "Completed",
        RFI: item?.Completed?.RFI,
        RFP: item?.Completed?.RFP,
        Auction: item?.Completed?.Auction,
        category: item?.category,
        total: ((item?.Completed?.RFI ?? 0) + (item?.Completed?.RFP ?? 0) + (item?.Completed?.Auction ?? 0))
      }
    ]);
  };

  // Calculate dynamic width
  const categoryCount = data?.length;
  const widthPerCategory = 250; // Base width for each category
  let calculatedWidth = categoryCount * widthPerCategory;

  if(calculatedWidth<=1350) {
    calculatedWidth = 1350;
  }

  return (
    <div style={{ width: '100%', overflowX: 'auto', overflowY: 'hidden' }}>
      {/* <div style={{ width: `${chartWidth}px`, height: '400px' }}> */}
      <BarChart
        width={calculatedWidth}  // Dynamically set width based on category count
        height={400}
        data={flattenData()}
        barGap={0}
        barSize={30}
        margin={{ top: 20, right: 30, left: 20, bottom: 50 }}
      >
        <CartesianGrid strokeDasharray="0" vertical={false} horizonal={true}  />
        <XAxis
          dataKey="name"
          tickLine={false}
          tick={<CustomXAxisTick />}
        />
        <YAxis 
          axisLine={false}
          tickLine={false}
          allowDecimals={false}
          // label={{
          //   value: "Annualized Estimated Spend (MN USD)",
          //   angle: -90,
          //   position: "insideLeft",
          //   textAnchor: "middle",
          //   dy: 130,
          //   dx: -15,
          //   style: { fontSize: "14px", fontWeight: "500", fill: "#616161" },
          // }}
        />
        {/* <Tooltip verticalAlign="bottom" height={56} /> */}
        <Tooltip content={<CustomTooltip />} cursor={{ fill: "transparent" }}/>
        <Bar dataKey="RFI" stackId="a" fill="#E66A00">
          {/* <LabelList dataKey="total" position="top" /> Display total at top of each bar */}
        </Bar> 
        <Bar dataKey="RFP" stackId="a" fill="#800080" />
        {/* <Bar dataKey="Forward_Auction" stackId="a" fill="#B05788" /> */}
        <Bar dataKey="Auction" stackId="a" fill="#47554F">
          <LabelList dataKey="total" position="top" className='ariba-coverage-bar-label'/> {/* Display total at top of each bar */}
        </Bar>
      </BarChart>
      {/* </div> */}
    </div>
  );
};

export default AribaThreeColoredBarChart;